<script lang="ts">
    import src from '../../shared/Icons/svg/snap_to_grid.svg';
    import TemplateIcon from '../../shared/Icons/TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';
</script>

<TemplateIcon {src} {scale} alt={title} hover={title} on:click />
